<template>
  <a-drawer :title="title" :width="800" placement="right" :closable="false" @close="close" :visible="visible">
    <a-spin :spinning="confirmLoading">
      <a-form-model
        ref="form"
      
        :model="model"
        :rules="validatorRules"
      >
        <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" prop="parentId" label="家长id">
          <a-input placeholder="请输入家长id" v-model="model.parentId" />
        </a-form-model-item>
        <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" prop="memberId" label="会员id">
          <a-input placeholder="请输入会员id" v-model="model.memberId" />
        </a-form-model-item>
        <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" prop="phone" label="手机号">
          <a-input placeholder="请输入手机号" v-model="model.phone" />
        </a-form-model-item>
        <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" prop="amount" label="商品金额">
          <a-input-number v-model="model.amount" />
        </a-form-model-item>
        <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" prop="name" label="商品名称">
          <a-input placeholder="请输入商品名称" v-model="model.name" />
        </a-form-model-item>
        <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" prop="code" label="商品编码">
          <a-input placeholder="请输入商品编码" v-model="model.code" />
        </a-form-model-item>
        <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" prop="orderTime" label="下单时间">
          <a-date-picker showTime valueFormat="YYYY-MM-DD HH:mm:ss" v-model="model.orderTime" />
        </a-form-model-item>
        <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" prop="paymentTime" label="付款时间">
          <a-date-picker showTime valueFormat="YYYY-MM-DD HH:mm:ss" v-model="model.paymentTime" />
        </a-form-model-item>
        <a-form-model-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          prop="paymentType"
          label="支付类型"
        >
        <!-- (1-微信支付 2-支付宝支付) -->
          <a-input-number v-model="model.paymentType" />
        </a-form-model-item>
        <a-form-model-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          prop="status"
          label="订单状态"
        >
        <!-- （1-已下单 2-已付款 3-订单作废） -->
          <a-input-number v-model="model.status" />
        </a-form-model-item>
        <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" prop="tenantId" label="租户id">
          <a-input-number v-model="model.tenantId" />
        </a-form-model-item>
      </a-form-model>
    </a-spin>

    <div class="drawer-bootom-button">
      <a-button type="primary" @click="handleOk">确定</a-button>
      <a-button type="primary" @click="handleCancel">取消</a-button>
    </div>
  </a-drawer>
</template>

<script>
import { httpAction } from '@/api/manage'
import moment from 'moment'

export default {
  name: 'SchoolOrderModal',
  data() {
    return {
      title: '操作',
      visible: false,
      model: {},
      labelCol: {
       span: 12 
      },
      wrapperCol: {
           span: 12 
      },

      confirmLoading: false,
      validatorRules: {},
      url: {
        add: '/schoolOrder/add',
        edit: '/schoolOrder/edit',
      },
    }
  },
  created() {},
  methods: {
    add() {
      //初始化默认值
      this.edit({})
    },
    edit(record) {
      this.model = Object.assign({}, record)
      this.visible = true
    },
    close() {
      this.$emit('close')
      this.visible = false
      this.$refs.form.clearValidate()
    },
    handleOk() {
      const that = this
      // 触发表单验证
      this.$refs.form.validate((valid) => {
        if (valid) {
          that.confirmLoading = true
          let httpurl = ''
          let method = ''
          if (!this.model.id) {
            httpurl += this.url.add
            method = 'post'
          } else {
            httpurl += this.url.edit
            method = 'put'
          }
          httpAction(httpurl, this.model, method)
            .then((res) => {
              if (res.success) {
                that.$message.success(res.message)
                that.$emit('ok')
              } else {
                that.$message.warning(res.message)
              }
            })
            .finally(() => {
              that.confirmLoading = false
              that.close()
            })
        } else {
          return false
        }
      })
    },
    handleCancel() {
      this.close()
    },
  },
}
</script>

<style lang="less" scoped>
/**Button按钮间距*/
.ant-btn {
  margin-left: 30px;
  margin-bottom: 30px;
  float: right;
}
/**抽屉按钮样式*/
.drawer-bootom-button {
  position: absolute;
  bottom: -8px;
  width: 100%;
  border-top: 1px solid #e8e8e8;
  padding: 10px 16px;
  text-align: right;
  left: 0;
  background: #fff;
  border-radius: 0 0 2px 2px;
}
</style>
